import type { WorkspaceRoom } from '../../lib/wstypes'

/** Rooms in a session (01 §3.5). A horizontal rail on a phone, a row on a laptop. */
export function RoomTabs({
  rooms,
  activeId,
  onSelect,
  onAdd,
}: {
  rooms: WorkspaceRoom[]
  activeId: string | null
  onSelect: (roomId: string) => void
  onAdd: () => void
}) {
  if (rooms.length === 0) return null
  return (
    <div
      role="tablist"
      aria-label="Rooms"
      className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-1 sm:mx-0 sm:px-0"
    >
      {rooms.map((room) => (
        <button
          key={room.id}
          role="tab"
          type="button"
          aria-selected={room.id === activeId}
          onClick={() => onSelect(room.id)}
          className={`min-h-11 shrink-0 rounded-pill border px-4 text-sm font-semibold transition-colors ${
            room.id === activeId
              ? 'border-navy bg-navy text-white'
              : 'border-line bg-white text-ink hover:border-blue'
          }`}
        >
          {room.name}
        </button>
      ))}
      <button
        type="button"
        onClick={onAdd}
        className="min-h-11 shrink-0 rounded-pill border border-dashed border-line-2 bg-transparent px-4 text-sm font-semibold text-muted hover:border-blue hover:text-blue-deep"
      >
        + Room
      </button>
    </div>
  )
}
